const slickConfig = {
    /**
     * Slick config for universal constructor recommendations that can be placed anyware on the pages
     */
    universalSlickRecomm() {
        $('.js-slick-universal-recommendations')
            .not('.slick-initialized')
            .slick({
                autoplay: false,
                infinite: false,
                slidesToShow: 4,
                slideToScroll: 1,
                dots: false,
                rtl: document.documentElement.lang === 'ar',
                draggable: false,
                prevArrow: $('.recomm-image-arrows-left'),
                nextArrow: $('.recomm-image-arrows-right'),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1.5
                        }
                    }
                ]
            });

        $('.js-slick-universal-recommendations').slick('refresh');
    },
    /**
     * Slick config for add to cart recommendations
     */
    addToCartRecommendations() {
        $('.slick')
            .not('.slick-initialized')
            .slick({
                autoplay: false,
                infinite: false,
                slidesToShow: 2,
                slideToScroll: 1,
                dotsClass: 'slick-dots-custom',
                dots: true,
                rtl: document.documentElement.lang === 'ar',
                draggable: false,
                prevArrow: $('.recomm-image-arrows-left'),
                nextArrow: $('.recomm-image-arrows-right'),
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1.5
                        }
                    }
                ]
            });

        $('.slick').slick('refresh');
    }
};

module.exports = slickConfig;
